export default (clientHttp, apiVersion) => ({
  read(houseId, query) {
    return clientHttp.get(
      `${apiVersion}/houses/${houseId}/period_durations${query}`,
    )
  },
})
